<script setup lang="ts">
  defineOptions({ name: 'AppSidebarHeader' })
</script>

<template>
  <header class="app-sidebar-header flex flex-shrink-0 items-center justify-between pb-4">
    <slot />
  </header>
</template>
